import GearDigitizationIcon from './GearDigitizationIcon'

export default GearDigitizationIcon
